// @flow
import type { Element } from 'react';

import React, { Fragment } from 'react';
import keyBy from 'lodash/fp/keyBy.js';
import { Button, Table } from 'reactstrap';
import {
  OCCUPANCY_BY_STORY,
  OCCUPANCY_BY_STORY_LOCATION_SPECIFIER,
  OCCUPANCY_BY_STORY_OCCUPANCY,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import Field from '#components/pages/Models/Model/sections/support/forms/Field/index.js';
import { FieldFeedback, RenderInput } from '#components/support/forms/utility/index.js';
import Tip from '#components/support/tooltips/Tip/index.jsx';

type Props = {|
  form: string,
  fieldsByName: Object,
  fields: {
    length: number,
    map: Function,
    push: Function,
    remove: Function,
  },
  meta: { error: string },
|};

const renderOccupancyByStory = ({
  form,
  fieldsByName: parentFieldsByName,
  fields,
  meta,
}: Props): Element<typeof Fragment> => {
  const { error } = meta;
  const itemSchemaByName = keyBy('name', parentFieldsByName[OCCUPANCY_BY_STORY].itemSchema);
  const locationField = itemSchemaByName[OCCUPANCY_BY_STORY_LOCATION_SPECIFIER];
  const occupancyField = itemSchemaByName[OCCUPANCY_BY_STORY_OCCUPANCY];
  const allowDelete = fields.length > 1 || false;
  const occupancyByStoryRows = fields.map((field, index) => (
    <tr key={field}>
      <td>
        <Field
          form={form}
          id={`${field}.${locationField.name}`}
          name={`${field}.${locationField.name}`}
          type={locationField.type}
          component={RenderInput}
          format={locationField.format}
          normalize={locationField.normalize}
        />
        <FieldFeedback name={`${field}.${locationField.name}`} form={form} />
      </td>
      <td>
        <Field
          form={form}
          id={`${field}.${occupancyField.name}`}
          name={`${field}.${occupancyField.name}`}
          type={occupancyField.type}
          component={RenderInput}
        >
          {occupancyField.options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.text}
            </option>
          ))}
        </Field>
        <FieldFeedback name={`${field}.${occupancyField.name}`} form={form} />
      </td>
      <td>
        <Button color="link" onClick={() => fields.remove(index)} disabled={!allowDelete}>
          delete
        </Button>
      </td>
    </tr>
  ));
  return (
    <>
      <Table responsive className="occupancy-by-story-table">
        <thead>
          <tr>
            <th>
              Stories <Tip tipId="story" />
            </th>
            <th>
              Occupancy <Tip tipId="occupancyByStoryOccupancy" />
            </th>
          </tr>
        </thead>
        <tbody>{occupancyByStoryRows}</tbody>
      </Table>
      {error && <div className="text-danger">{error}</div>}
      <Button
        size="sm"
        id="addOccupancyRowButton"
        className="float-right"
        color="primary"
        onClick={() => fields.push({})}
      >
        Add Row
      </Button>
    </>
  );
};

export default renderOccupancyByStory;
